// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore, collection, getDocs } from 'firebase/firestore';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAMYaR51zHXUnyLBoCkee6sHe25bE1P33k",
  authDomain: "muslimpergi-umi.firebaseapp.com",
  databaseURL: "https://muslimpergi-umi.firebaseio.com",
  projectId: "muslimpergi-umi",
  storageBucket: "muslimpergi-umi.appspot.com",
  messagingSenderId: "685505277317",
  appId: "1:685505277317:web:4df3ec27621fc702f0a8ec",
  measurementId: "G-P6NF08S8EX"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export default db;